import MainStack from './MainStack';

export default MainStack;
